import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../shared/service/app.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { HeaderComponent } from './header';
import { FooterComponent } from './footer';
import { SidebarComponent } from './sidebar';
import { ThemeCustomizerComponent } from './theme-customizer';
import { SharedModule } from 'src/shared.module';
import { CommonModule } from "@angular/common";

@Component({
    selector: 'app-root',
    templateUrl: './app-layout.html',
    standalone: true,
    imports: [
        SharedModule,
        HeaderComponent,
        FooterComponent,
        SidebarComponent,
        ThemeCustomizerComponent,
        CommonModule
    ]
})
export class AppLayout {
    store: any;
    showTopButton = false;
    constructor(public translate: TranslateService, public storeData: Store<any>, private service: AppService, private router: Router) {
        this.initStore();
    }
    headerClass = '';
    private scrollListener = () => {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            this.showTopButton = true;
        } else {
            this.showTopButton = false;
        }
    };

    ngOnInit() {
        this.initAnimation();
        this.toggleLoader();
        window.addEventListener('scroll', this.scrollListener);
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', this.scrollListener);
    }

    initAnimation() {
        this.service.changeAnimation();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.service.changeAnimation();
            }
        });

        const ele: any = document.querySelector('.animation');
        ele.addEventListener('animationend', () => {
            this.service.changeAnimation('remove');
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
